import { gql } from 'apollo-angular'

export const GET_MAGAZINE_FILTER_ITEMS = gql`
  query getMagazineFilterItems($page: Int, $limit: Int) {
    Magazines(
      select: true
      page: $page
      limit: $limit
      sort: "title"
      where: { published: { equals: true } }
    ) {
      docs {
        id
        title
      }
      page
      totalPages
    }
  }
`
